import React from "react";
import LegalPage from "components/Legal/LegalPage.jsx";

export default function ImpressumPage() {
    return (
        <LegalPage title="Impressum">
            <h2>Angaben gemäß § 5 DDG</h2>
            <p>
                Daniel Hackel
                <br />
                38229 Salzgitter
                <br />
                Deutschland
            </p>

            <p>
                E-Mail: daniel.hackel@t-online.de
                <br />
                Telefon: [00491736433892]
            </p>
            <h2>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
            <p>
                Daniel Hackel
                <br />
                38229 Salzgitter
            </p>

            <h2>Verbraucherstreitbeilegung</h2>
            <p>
                Wir sind nicht verpflichtet und nicht bereit, an Streitbeilegungsverfahren
                vor einer Verbraucherschlichtungsstelle teilzunehmen.
            </p>
        </LegalPage>
    );
}